/*
 * Lebensmittelhygiene und Allergeninformation (Anforderung #96) — die eine
 * Frage, die die Oberfläche selbst beantworten muss: Gilt die Bestätigung für
 * die **gerade gewählte** Branche?
 *
 * Für die Checkliste rechnet das der Server (`activationsStatus`). Im
 * Unternehmensprofil zählt dagegen die Auswahl im Feld, auch bevor sie
 * gespeichert ist — sonst erschiene der Hinweis erst nach dem Speichern, und
 * genau davor soll er gelesen werden.
 *
 * Verglichen wird gegen beide Fassungen der Stammdatenliste: Der Bestand trägt
 * die Branche mal englisch (`value_EN`, so speichert die Anwendung heute), mal
 * deutsch (ältere Junior Companies). Wer nur eine Fassung prüft, lässt die
 * halbe Liste durch — derselbe Befund wie in Anforderung #77.
 */

const normalize = value =>
	String(value || '')
		.trim()
		.toLowerCase()

/**
 * @param options  Die Options aus dem Store (`hygieneTraining` und `branch`).
 * @param branch   Die gewählte Branche, deutsch oder englisch.
 */
export const hygieneAppliesToBranch = (options, branch) => {
	if (!branch) return false

	const konfiguriert = options?.hygieneTraining?.branches
	// Keine gepflegte Liste heißt: Die Regel greift nirgends. Ein Startwert an
	// dieser Stelle würde etwas verlangen, was in den Einstellungen nicht steht.
	if (!Array.isArray(konfiguriert) || !konfiguriert.length) return false

	const gesucht = new Set(konfiguriert.map(normalize))

	const liste = Array.isArray(options?.branch) ? options.branch : []
	liste.forEach(row => {
		const en = normalize(row?.value_EN)
		const de = normalize(row?.value_DE)

		if (gesucht.has(en) || gesucht.has(de)) {
			if (en) gesucht.add(en)
			if (de) gesucht.add(de)
		}
	})

	return gesucht.has(normalize(branch))
}
